// extracted by mini-css-extract-plugin
module.exports = {"tabs":"AgentsTabsPage_tabs__rxKS7"};